var map = {
	"./bitcoin_halving_controller.js": 70578,
	"./coin_chart_controller.js": 27750,
	"./coin_historical_data_controller.js": 18225,
	"./coin_insight_breakdown_modal_controller.js": 62112,
	"./coin_insights_controller.js": 70821,
	"./coin_insights_modal_controller.js": 8067,
	"./coin_insights_vote_controller.js": 46828,
	"./coin_show_controller.js": 12025,
	"./converter_controller.js": 19394,
	"./tokenomic_emissions_chart_controller.js": 27945,
	"./tokenomic_financials_chart_building_controller.js": 29630,
	"./tokenomic_financials_chart_setting_controller.js": 22890,
	"controllers_v2/coins/bitcoin_halving_controller.js": 70578,
	"controllers_v2/coins/coin_chart_controller.js": 27750,
	"controllers_v2/coins/coin_historical_data_controller.js": 18225,
	"controllers_v2/coins/coin_insight_breakdown_modal_controller.js": 62112,
	"controllers_v2/coins/coin_insights_controller.js": 70821,
	"controllers_v2/coins/coin_insights_modal_controller.js": 8067,
	"controllers_v2/coins/coin_insights_vote_controller.js": 46828,
	"controllers_v2/coins/coin_show_controller.js": 12025,
	"controllers_v2/coins/converter_controller.js": 19394,
	"controllers_v2/coins/tokenomic_emissions_chart_controller.js": 27945,
	"controllers_v2/coins/tokenomic_financials_chart_building_controller.js": 29630,
	"controllers_v2/coins/tokenomic_financials_chart_setting_controller.js": 22890
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5285;